import { useSlots, toRefs, computed } from 'vue';
import RatioBox from '../../components/ratio-box/component-lib.esm.js';
import { isImageIcon, convertImageUrlToEncodedUrl } from '../../utils/component-lib.esm19.js';

//
var script = {
  components: {
    RatioBox
  },
  props: {
    component: {
      type: String,
      default: 'a'
    },
    label: String,
    url: String,
    imageUrl: String,
    highlight: String,
    type: String,
    disabled: Boolean,
    textClass: Object,
    variant: {
      type: String,
      default: null
    },
    imageStyle: String,
    size: String
  },
  setup(props) {
    const slots = useSlots();
    const {
      imageStyle
    } = toRefs(props);
    const attributes = computed(() => {
      if (props.component === 'a') {
        return {
          target: '_blank',
          rel: 'noopener ugc',
          href: props.url
        };
      } else {
        return {
          type: props.type || 'button'
        };
      }
    });
    const hasImage = computed(() => {
      return !!props.imageUrl;
    });
    const isIcon = computed(() => {
      return isImageIcon(props.imageUrl);
    });
    const imageSrc = computed(() => {
      return convertImageUrlToEncodedUrl(props.imageUrl, 150);
    });
    const buttonClasses = computed(() => {
      return {
        'site-btn': true,
        'site-btn--has-img': hasImage.value,
        'site-btn--has-icon': slots['icon-right'],
        'site-btn--img-circle': imageStyle && imageStyle.value === 'circle',
        [`site-btn--${props.size}`]: props.size,
        [`site-btn--${props.variant}`]: props.variant,
        [`site-btn--anim-${props.highlight}`]: props.highlight
      };
    });
    const imageClasses = computed(() => {
      return {
        'site-btn__img': true,
        'site-btn__img--circle': imageStyle && imageStyle.value === 'circle'
      };
    });
    return {
      attributes,
      hasImage,
      buttonClasses,
      imageClasses,
      imageSrc,
      isIcon
    };
  }
};
export { script as default };